import React from 'react';
import PropTypes from 'prop-types';

import { Picture } from '@comparethemarketau/manor-picture';
import { getAssetFilePath } from '../../summary/common/get_asset_file_path';

const AlexanderNoResults = ({ className }) => {
    const imgSrc = getAssetFilePath('/assets/brand/ctm/images/alexander_no_results.png');

    // Note: for the Picture Component the alt text has been set to empty because this is a Decorative Image - supplying
    // alt text here is only a distraction for visually impaired users - ensure that relevant alt text is included for
    // any informative, descriptive, or functional images / icons
    return (
        <Picture src={imgSrc} alt={''} className={className} />
    );
};

AlexanderNoResults.propTypes = {
    className: PropTypes.string
};

export { AlexanderNoResults };
